export default {
    'ABHI FINANCE SERVICES LIMITED': '20',
    'AFT': '23',
    'AFT IBFT': '13',
    'Advans': '96',
    'Al Meezan Investment Management Limited': '28',
    'Bank AlHabib Limited': '627197',
    'Al Baraka Bank Limited': '639530',
    'Bank Al Falah Limited': '627100',
    'Allied Bank Limited': '589430',
    'Apna Microfinance Bank': '581862',
    'Askari Commercial Bank Limited': '603011',
    'BOK': '87',
    'BYKEA': '999921',
    'Bank Islami Pakistan limited': '639357',
    'Burj Bank Limited': '67',
    'Central Directorate of National Savings': '15',
    'Central Directorate of National Savings (CDNS)': '27',
    'Central Directorate of National Savings (CDNS) – 1IBFT IMD Addition': '122',
    'Citi Bank': '508117',
    'Dubai Islamic Bank': '428273',
    'EZ wage': '110',
    'Telenor Microfinance bank': '639390',
    'First women Bank limited': '628138',
    'FINCA': '86',
    'FINJA': '97',
    'FWBL': '90',
    'Faysal Bank Limited': '601373',
    'Habib Bank Limited': '600648',
    'HBL ASSET MANAGEMENT': '102',
    'Habib Metro Bank – Bulk 1IBFT': '118',
    'Habib Metropolitan Bank Limited': '601724',
    'Humrah Financial Services': '113',
    'ICBC': '95',
    'JS Bank': '603733',
    'KASB Bank': '51',
    'KBL': '94',
    'KEENU': '22',
    'KEENU Bank': '24',
    'KEENU - IMD and 1IBFT Screen Addition': '14',
    'Keenu1': '115',
    'MCB Bank Limited': '589388',
    'MCB-Arif Habib': '100',
    'MIB': '91',
    'Meezan Bank': '627873',
    'Mobilink Microfinance Bank Limited': '585953',
    'NayaPay Private Limited': '478278',
    'NBP': '89',
    'NBP Fund Management Limite': '98',
    'NBP1': '93',
    'NIB Bank': '65',
    'NRSP': '88',
    'National Bank of Pakistan': '958600',
    'Numbers Private Limited': '114',
    'PayMax': '55',
    'PayMax1': '104',
    'SadaPay': '559049',
    'Standard Chartered Bank': '627271',
    'SEEDCREED Financial Services Limited': '50',
    'SIND'  : '83',
    'SAMBA': '606101',
    'SILK Bank': '627544',
    'Sindh Bank': '505439',
    'Soneri Bank Limited': '786110',
    'TAG': '12',
    'TezPAy': '103',
    'United Bank Limited': '588974',
    'UPaisa': '85',
    'Waseela': '70',
    'Waseela bank': '1',
    'ZTBL1': '101',
    'Zarai Taraqiati Bank': '42',
    'UBank': '581886'
  };